import { createActions, createReducer } from 'reduxsauce'

import PredioService from '_/servicos/PredioService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaPredioInicio: [],
    buscaPredioSucesso: ['predio'],
    buscaPredioErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaPredio = () => {
    return dispatch => {
        dispatch(Creators.buscaPredioInicio())
        let serv = new PredioService()
        return serv
            .getPredios()
            .then(response => dispatch(Creators.buscaPredioSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaPredioErro(error)))
    }
}

const buscaPredioInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaPredioErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaPredioSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.predio, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_PREDIO_INICIO]: buscaPredioInicio,
    [Types.BUSCA_PREDIO_ERRO]: buscaPredioErro,
    [Types.BUSCA_PREDIO_SUCESSO]: buscaPredioSucesso,
})
